export default [
  {
    title: 'breadcrumb.betSetting',
    route: 'bet-setting',
    icon: '',
    resource: 'bet-setting',
    action: 'read',
  },
  {
    title: 'breadcrumb.jackpotSetting',
    route: 'jackpot-setting',
    icon: '',
    resource: 'bet-setting',
    action: 'read',
  },
]
